import React, { Component } from 'react';
import styled, { css } from 'styled-components';
// import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from 'common/Spinner';
import ErrorMessage from 'common/Error';
import { editUser, removeRfid } from 'redux/modules/duck-admin';

import PropTypes from 'prop-types';

import { baseFont } from 'utils/fonts';
import { mobile } from 'utils/media';
import colors from 'utils/colors';
import { warning } from 'react-notification-system-redux';

const Loader = styled(Spinner)`
  margin: 0 auto;
`;

const FormWrapper = styled.form`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: 'relative';
`;

//TODO: componentDidUpdate for profile and rfidInput. Either here or on manage.
class AddRfidForm extends Component {
  constructor(props) {
    super(props);

    this.state = { rfidInput: '' };
    this.submitRfid = this.submitRfid.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.removeCredential = this.removeCredential.bind(this);
  }

  handleChange(e) {
    this.setState({ rfidInput: e.target.value });
  }

  submitRfid(e) {
    const { userId, selectedSystem, editUser, userEdit } = this.props;

    if (userEdit) {
      editUser(userEdit._id, selectedSystem._id, this.state.rfidInput);
    } else {
      editUser(userId, selectedSystem._id, this.state.rfidInput);
    }

    e.preventDefault();
  }

  removeCredential(e) {
    const { selectedSystem, removeRfid, userEdit } = this.props;
    removeRfid(userEdit._id, selectedSystem._id, 'pending');
    e.preventDefault();
  }

  render() {
    const {
      err,
      loading,
      systems,
      link,
      linkLoading,
      linkError,
      userEdit,
      selectedSystem,
    } = this.props;

    return (
      <FormWrapper>
        <label style={{ textAlign: 'left', fontSize: 24, color: '#083E66' }}>
          Scan / Type Credential
        </label>
        <input
          type="text"
          defaultValue={userEdit ? userEdit.rfid : ''}
          onChange={this.handleChange}
          style={{ height: 30, width: 450, fontSize: 20 }}
          ref={(input) => (this.input = input)}
        />
        <button
          style={{
            height: 50,
            width: 200,
            backgroundColor: '#3E3E58',
            alignSelf: 'right',
            fontSize: 16,
            color: 'white',
            position: 'absolute',
            bottom: 30,
            right: userEdit ? 375 : 120,
          }}
          onClick={this.submitRfid}
        >
          {loading ? <Loader /> : 'Save'}
        </button>
        {userEdit ? (
          <button
            style={{
              height: 50,
              width: 200,
              backgroundColor: '#CB4C6F',
              alignSelf: 'right',
              fontSize: 16,
              color: 'white',
              position: 'absolute',
              bottom: 30,
              right: 120,
            }}
            onClick={this.removeCredential}
          >
            {loading ? <Loader /> : 'Remove Credential'}
          </button>
        ) : null}

        {err ? <ErrorMessage>{err.message}</ErrorMessage> : null}
      </FormWrapper>
    );
  }
}

AddRfidForm.contextTypes = {
  store: PropTypes.object,
};

function mapStateToProps({ auth, admin, form }) {
  const { owner_systems, selectedSystems } = admin;
  return {
    owner_systems,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      editUser,
      removeRfid,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddRfidForm);



// WEBPACK FOOTER //
// ./src/Admin/AddRfidForm.js